import { WarningRounded } from '@mui/icons-material'
import { Box, Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog } from '@mui/joy'
import PropTypes from 'prop-types'
import CustomDatePickerControl from './forms/CustomDatePickerControl'
import { FormikProvider, useFormik } from 'formik'
import { newDateModalSchema } from 'validations/project/addTasksSchema'

const EditDateModal = ({
  open,
  setObject,
  handleEdit,
  loading = false,
  children,
  btnText = 'Edytuj',
  title = 'Potwierdzenie',
}) => {
  const formik = useFormik({
    initialValues: {
      newDate: '',
    },
    validationSchema: newDateModalSchema,
    onSubmit: (values) => {
      handleEdit(values.newDate)
    },
  })

  return (
    <Modal open={Boolean(open)} onClose={() => setObject(false)}>
      <ModalDialog variant="outlined" role="alertdialog">
        <DialogTitle>
          <WarningRounded />
          {title}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {children}
          <Box sx={{ mt: 1, mb: 3 }}>
            <FormikProvider value={formik}>
              <form onSubmit={formik.handleSubmit}>
                <CustomDatePickerControl
                  name="newDate"
                  label="Nowy termin"
                  formik={formik}
                  sx={{ flex: '1', minWidth: '1px' }}
                />
              </form>
            </FormikProvider>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="solid"
            color="danger"
            onClick={() => handleEdit(formik.values.newDate)}
            loading={loading}
            disabled={!(formik.isValid && formik.dirty)}
          >
            {btnText}
          </Button>
          <Button variant="plain" color="neutral" onClick={() => setObject(false)} loading={loading}>
            Anuluj
          </Button>
        </DialogActions>
      </ModalDialog>
    </Modal>
  )
}

EditDateModal.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object, PropTypes.array]).isRequired,
  setObject: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  btnText: PropTypes.string,
  title: PropTypes.string,
}

export default EditDateModal
